import {axiosGetAuthorize, axiosPostAuthorize} from '../AxiosRequests';
import {GetVendorsList,DeleteVendors,UpdateVendors,GetVendorsById,AddVendors,GetAllActiveVendors,GetAssignVendorsByGroupId,GetUnAssignVendorsByGroupId,AssingVendorsToGroup,
    UnAssingGrouptoVendors,GetActiveVendorsForEmail,GetVendorGrabbersByVendorId,AddVendorGrabbers} from '../ApiEndPoints';

export default class VendorServices {

        //** Call API : Get User List */
        async addVendors(request){
            return axiosPostAuthorize(AddVendors, request);
        }
         
        async updateVendors(request){
            return axiosPostAuthorize(UpdateVendors, request);
        }

        async deleteVendors(request){
            return axiosPostAuthorize(DeleteVendors,request);
        }

        async getVendorsList(request){
            return axiosPostAuthorize(GetVendorsList, request);
        }

        async getVendorsById(request){
            return axiosGetAuthorize(GetVendorsById, request);
        }

        async getAllActiveVendors(request){
            return axiosGetAuthorize(GetAllActiveVendors, request);
        }

        async getAssignVendorsByGroupId(request){
            return axiosGetAuthorize(GetAssignVendorsByGroupId, request);
        }

        async getUnAssignVendorsByGroupId(request){
            return axiosGetAuthorize(GetUnAssignVendorsByGroupId, request);
        }
        async assingVendorsToGroup(request){
            return axiosPostAuthorize(AssingVendorsToGroup, request);
        }
        async unAssingGrouptoVendors(request){
            return axiosPostAuthorize(UnAssingGrouptoVendors, request);
        }
        async getActiveVendorsForEmail(request){
            return axiosGetAuthorize(GetActiveVendorsForEmail, request);
        }    
        async getVendorGrabbersByVendorId(request){
            return axiosGetAuthorize(GetVendorGrabbersByVendorId, request);
        }   
        async addVendorGrabbers(request){
            return axiosPostAuthorize(AddVendorGrabbers, request);
        }         
        
}